import useSuperUserHook from './useSuperUserHook';

const useIsDemoTrial = () => {
  const session = useSuperUserHook();
  const isDemoTrial = session?.data?.iss === 'DEMO_TRIAL';

  return isDemoTrial;
};

export default useIsDemoTrial;
